export const NOT_ALPHA_NUMBER_REG = /[^A-Za-z0-9 ]/g
export const NOT_NUMBER_COMMA = /[^0-9,.]/g
export const NOT_NUMBER = /^\d+$/
export const IS_NUMBER = /^[0-9]+$/
export const CONDITION_PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/
export const PHONE_NUMBER_REG =
  /((^(\+84|84|0|0084|02){1})(1|2|3|5|6|7|8|9))+([0-9]{8})$/
export const EMAIL_REG =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
